import React from 'react';

import NearbyList from './NearbyList/NearbyList';

const hotelNearby = () => (
    <div className={`pt-6 pb-6 u-width100Percent u-backgroundColorWhite phone-pl-3 phone-pr-3 phone-pb-4 phone-pt-4`}>
        <div className={`u-flex justify-content-around phone-f-column`}>
            <NearbyList/>
        </div>
    </div>
);

export default hotelNearby;


// WEBPACK FOOTER //
// ./src/components/HotelDetail/HotelNearby/HotelNearby.js